"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
function getInitTime() {
    // @ts-ignore
    if (!window.performance && !window.performance.timeOrigin) {
        throw new Error('Performance value not set');
    }
    return window.performance.timeOrigin;
}
exports.default = getInitTime;
